import React from 'react';
import { RefreshCw, WifiOff } from 'lucide-react';

interface NetworkErrorProps {
    onRetry: () => void;
    title?: string;
    message?: string;
}

const NetworkError: React.FC<NetworkErrorProps> = ({ 
    onRetry, 
    title = "Connection Lost", 
    message = "We couldn't reach the servers. Please check your network and try again." 
}) => {
    return (
        <div className="flex flex-col items-center justify-center py-20 px-6 text-center space-y-4">
            <div className="w-16 h-16 bg-slate-100 dark:bg-slate-800 rounded-full flex items-center justify-center mb-2">
                <WifiOff className="w-8 h-8 text-slate-400 dark:text-slate-500" />
            </div>
            <h3 className="text-lg font-bold text-slate-900 dark:text-white poppins">{title}</h3>
            <p className="text-sm text-slate-500 dark:text-slate-400 max-w-xs leading-relaxed">{message}</p>
            <button
                onClick={onRetry}
                className="mt-6 flex items-center gap-2 px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white rounded-full text-sm font-bold transition-all active:scale-95 shadow-md shadow-indigo-500/20"
            >
                <RefreshCw size={16} />
                Retry Connection
            </button>
        </div>
    );
};

export default NetworkError;
